import { FileTypes } from "../enums/FileUploadEnums";

export const mimeTypeLabels = {
  [FileTypes.PDF]: "pdf",
  [FileTypes.IMAGES]: "Image",
  [FileTypes.DOC]: "doc",
  [FileTypes.DOCX]: "docx",
  [FileTypes.XLS]: "xls",
  [FileTypes.XLSX]: "xlsx",
  [FileTypes.CSV]: "csv",
  [FileTypes.PNG]: "png",
  [FileTypes.JPEG]: "jpg",
  [FileTypes.JPG]: "jpeg",
};
